import { createStyles, makeStyles, Theme } from 'ui-components';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
  slidersCaption: {
    marginTop: 8,
  },
  container: {
    padding: '24px 0',
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
    '& $chooseInvestmentWrapper': {
      '&:last-child': {
        '&:after': {
          display: 'none',
        },
      },
    }
  },
  chooseInvestmentWrapper: {
    position: 'relative',
    paddingRight: 32,
    width: '100%',
    '&:after': {
      content: '""',
      width: 1,
      height: 120,
      background: theme.color.greys[20],
      position: 'absolute',
      right: 0,
      top: 21,
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    [theme.breakpoints.down('sm')]: {
      borderRight: 'none',
      borderBottom: `1px solid ${theme.color.greys[20]}`,
      paddingRight: 0,
      paddingBottom: 32,
      marginBottom: 32,
    },
  },
  chooseInvestmentWrapperMonthlyPaymant: {
    paddingLeft: 32,
    borderRight: 'none',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 0,
      paddingBottom: 24,
    },
  },
  errorWrapper: {
    boxSizing: 'border-box',
    padding: '12px 24px',
    background: theme.color.greys[0],
    borderRadius: 2,
    border: `1px solid ${theme.color.greys[20]}`,
    boxShadow: '0px 16px 32px rgba(0, 0, 0, 0.16)',
    position: 'absolute',
    maxWidth: 302,
    zIndex: 3,
    width: 302,
    right: -50,
    top: -139,
    [theme.breakpoints.down('sm')]: {
      top: -82,
      right: '50%',
      transform: 'translateX(50%)',
    },
    '&:after': {
      content: '""',
      width: 12,
      height: 12,
      position: 'absolute',
      zIndex: 2,
      left: '50%',
      transform: 'translateX(-50%) rotate(45deg)',
      bottom: -7,
      background: theme.color.greys[0],
      borderRight: `1px solid ${theme.color.greys[20]}`,
      borderBottom: `1px solid ${theme.color.greys[20]}`,
    },
  },
  sliderCaption: {
    marginTop: 4,
  },
  errorWrapperIke: {
    top: -79,
    right: -10,
    [theme.breakpoints.down('sm')]: {
      top: -25,
      right: '50%',
      transform: 'translateX(50%)',
    },
  },
  sliderWrapper: {
    marginBottom: 32,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  sliderInputWrapper: {
    maxWidth: 170,
  },
  errorMessage: {
    position: 'absolute',
  },
}), { name: 'ChooseInvestmentSliders' });
